// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EcoStatsData } from './EcoStatsData';
import {
    EcoStatsDataFromJSON,
    EcoStatsDataFromJSONTyped,
    EcoStatsDataToJSON,
    EcoStatsDataToJSONTyped,
} from './EcoStatsData';

/**
 * 
 * @export
 * @interface EcoStats
 */
export interface EcoStats {
    /**
     * 
     */
    data?: EcoStatsData;
}

/**
 * Check if a given object implements the EcoStats interface.
 */
export function instanceOfEcoStats(value: object): value is EcoStats {
    return true;
}

export function EcoStatsFromJSON(json: any): EcoStats {
    return EcoStatsFromJSONTyped(json, false);
}

export function EcoStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcoStats {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : EcoStatsDataFromJSON(json['data']),
    };
}

export function EcoStatsToJSON(json: any): EcoStats {
    return EcoStatsToJSONTyped(json, false);
}

export function EcoStatsToJSONTyped(value?: EcoStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EcoStatsDataToJSON(value['data']),
    };
}

